import React from 'react';

const CartIconByRydens = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.99927 8L7.99927 7C7.99927 4.79086 9.79013 3 11.9993 3V3C14.2084 3 15.9993 4.79086 15.9993 7L15.9993 8"
                stroke="#1E1E1E"
                strokeLinecap="round"
            />
            <path d="M5.49927 8.5H18.4993V20.5H5.49927V8.5Z" stroke="#1E1E1E" />
        </svg>
    );
};

export default CartIconByRydens;
